import { PaginationResponse, QueryManager } from '@/packages'
import { queryClient } from '../queryClient'
import { useFlatlistProps } from '@/utils'
import { CommunityFeed, CommunitySearchFeed } from '@/types'
import { api } from '@/app'

const BASE_URL = 'community/v2/search/'
const PROFILE_URL = 'community/v2/me/'

function getSearchCardData(item: CommunitySearchFeed | CommunityFeed): CommunitySearchFeed {
  return 'post' in item && item.post ? item.post : (item as CommunitySearchFeed)
}

export const communitySearchManager = new QueryManager({
  itemType: {} as CommunitySearchFeed,
  name: 'community',
  queryClient: queryClient.client,

  listItems: async (limit, offset, filters) => {
    const url = filters.me ? PROFILE_URL : BASE_URL

    const response = await api.get<PaginationResponse<CommunitySearchFeed>>(url, {
      params: {
        limit,
        offset,
        search: filters.search
      }
    })

    if (filters.me) {
      const results = response.data.results.map(getSearchCardData)

      return { ...response.data, results }
    }

    return response.data
  }
})

export function useCommunitySearch(search: string, me = false) {
  const community = communitySearchManager.use({ filter: { search, me } })

  const listProps = useFlatlistProps(community)

  return { community, listProps }
}
